
riot.tag2('sms-settings', '  <loader if="{loader}"></loader>\n  <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group">\n          <div class="btn-group">\n            <button class="btn btn-default" type="button" onclick="{save}"><i class="fa fa-save"></i> Сохранить</button>\n            <button class="btn btn-default" type="button" onclick="{reload}"><i class="fa fa-refresh"></i></button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group">\n          <label class="control-label">Провайдер</label>\n          <div class="input-group">\n            <select class="form-control" name="id" value="{item.id}">\n              <option each="{p, i in providers}" __selected="{p.id == item.id}" value="{p.id}" no-reorder>{p.name}</option>\n            </select>\n            <div class="input-group-btn" if="{link}"><a class="btn btn-default" target="_blank" href="{link}" title="Перейти на сайт"><i class="fa fa-link"></i></a></div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <virtual each="{settings}">\n          <div class="form-group" if="{name == &quot;password&quot;}">\n            <label class="control-label">{name}</label>\n            <input class="form-control" name="{name}" value="{parent.item[name]}" type="password">\n          </div>\n          <div class="form-group" if="{type == &quot;string&quot; &amp;&amp; name != &quot;password&quot;}">\n            <label class="control-label">{name}</label>\n            <input class="form-control" name="{name}" value="{parent.item[name]}" type="text">\n          </div>\n        </virtual>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <div class="form-group" if="{balance !== undefined}">\n          <label class="control-label">Баланс</label>\n          <p class="form-control-static">{balance || 0}</p>\n        </div>\n      </div>\n    </div>\n    <div class="row" if="{description}">\n      <div class="col-md-12">\n        <blockquote>\n          <p class="form-control-static" each="{d in description}">{d}</p>\n        </blockquote>\n      </div>\n    </div>\n  </form>\n', 'sms-settings,[riot-tag="sms-settings"],[data-is="sms-settings"]{ display: block; position: relative; }', '', function(opts) {
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.loader = false;
self.item = {};
self.mixin('change');

self.providers = [];
self.settings = [];

self.afterChange = function (e) {
    var name = e.target.name;
    var value = e.target.value;

    if (name === 'id') {
        self.settings = [];
        var active = self.providers.filter(function (item) {
            return item.id == self.item.id;
        });

        if (active.length) {
            self.link = /http(s)*:\/\//.test(active[0].url) ? active[0].url : 'http://' + active[0].url;
            self.item = { id: value };
            self.balance = undefined;

            API.request({
                object: 'SmsProvider',
                method: 'info',
                data: { id: value },
                success: function success(response) {
                    self.balance = response.balance;
                    self.description = response.description;
                    self.update();
                }
            });

            try {
                var settings = JSON.parse(active[0].settings);
                for (var param in settings) {
                    var item = (0, _extends3.default)({ name: param }, settings[param]);
                    self.settings.push(item);
                    self.item[param] = settings[param].value || '';
                }
            } catch (e) {
                self.settings = [];
            }
        }
    }
};

self.save = function () {
    var params = {
        id: self.item.id,
        settings: '',
        isActive: '1'
    };

    var active = self.providers.filter(function (item) {
        return item.id == self.item.id;
    })[0];
    var activeSettings = JSON.parse(active.settings);
    var settings = {};

    for (var param in self.item) {
        if (param !== 'id') {
            settings[param] = (0, _extends3.default)({}, activeSettings[param], { value: self.item[param] });
        }
    }

    params.settings = (0, _stringify2.default)(settings);

    API.request({
        object: 'SmsProvider',
        method: 'Save',
        data: params,
        success: function success(response) {
            popups.create({ title: 'Успех!', text: 'Сохраненно!', style: 'popup-success' });
        }
    });
};

self.reload = function () {
    self.settings = [];
    self.loader = true;
    self.update();

    API.request({
        object: 'SmsProvider',
        method: 'Fetch',
        success: function success(response) {
            self.providers = response.items;
            var active = self.providers.filter(function (item) {
                return item.isActive == 1;
            });
            self.balance = undefined;
            self.update();

            if (active.length) {
                self.link = /http(s)*:\/\//.test(active[0].url) ? active[0].url : 'http://' + active[0].url;
                API.request({
                    object: 'SmsProvider',
                    method: 'info',
                    data: { id: active[0].id },
                    success: function success(response) {
                        self.balance = response.balance;
                        self.description = response.description;
                        self.update();
                    }
                });

                self.item = { id: active[0].id };

                try {
                    var settings = JSON.parse(active[0].settings);
                    for (var param in settings) {
                        var item = (0, _extends3.default)({ name: param }, settings[param]);
                        self.settings.push(item);
                        self.item[param] = settings[param].value || '';
                    }
                } catch (e) {
                    self.settings = [];
                }
            }
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
};

self.on('mount', function () {
    self.reload();
});
});


// WEBPACK FOOTER //
// ./pages/settings/sms/sms-settings.tag